import c from "styled-components";
import { Sizes as t } from "./atoms-v2824.js";
const p = {
  "cc-affirm": {
    height: "22px",
    width: "145px"
  },
  "cc-amex": {
    height: "14px",
    width: "67px"
  },
  "cc-apple-pay": {
    height: "20px",
    width: "47px"
  },
  "cc-diners": {
    height: "24px",
    width: "31px"
  },
  "cc-discover": {
    height: "15px",
    width: "88px"
  },
  "cc-google-pay": {
    height: "22px",
    width: "55.4px"
  },
  "cc-jcb": {
    height: "24px",
    width: "33px"
  },
  "cc-mastercard": {
    height: "24px",
    width: "39px"
  },
  "cc-paypal": {
    height: "21px",
    width: "79.21px"
  },
  "cc-visa": {
    height: "16px",
    width: "51px"
  }
}, d = c.i`
  display: inline-flex;
  height: ${({ $isCC: h, $size: i }) => h ? p[h].height : t[i]};
  width: ${({ $isCC: h, $size: i }) => h ? p[h].width : t[i]};

  & svg {
    fill: currentcolor;
    height: 100%;
    width: 100%;
  }
`;
export {
  d as Icon
};
